module.exports = __webpack_public_path__ + "img/235.carousel_door.fd954f4f.svg";